import http from '@util/http';
import {core} from '@api/req';

export async function querySerialNumberList(params) {
  return http.get(core.GET_SERIALNUMBER_LIST, params);
}

export async function querySerialNumberInfo(params) {
  return http.get(core.GET_SERIALNUMBER_INFO, params);
}

export async function querySaveSerialNumber(params) {
  return http.post(core.SAVE_SERIALNUMBER, params);
}

export async function queryDeleteSerialNumber(params) {
  return http.get(core.DELETE_SERIALNUMBER, params);
}



// WEBPACK FOOTER //
// ./src/api/core/serialNumber.js